import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseButton } from './components/base-button/Component.js';
import 'react-merge-refs';
import 'classnames';
import '@alfalab/core-components-shared/esm';
import '@alfalab/core-components-spinner/esm';
import '@alfalab/hooks';

var defaultColors = {"secondary":"button__secondary_1oxip","ghost":"button__ghost_1oxip","component":"button__component_1oxip","primary":"button__primary_1oxip","tertiary":"button__tertiary_1oxip","link":"button__link_1oxip"};
require('./default.mobile.css')

var invertedColors = {"secondary":"button__secondary_pjt70","ghost":"button__ghost_pjt70","component":"button__component_pjt70","primary":"button__primary_pjt70","tertiary":"button__tertiary_pjt70","link":"button__link_pjt70"};
require('./inverted.mobile.css')

var styles = {"xxs":"button__xxs_fpzaj","xs":"button__xs_fpzaj","s":"button__s_fpzaj","m":"button__m_fpzaj","l":"button__l_fpzaj","xl":"button__xl_fpzaj"};
require('./mobile.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var ButtonMobile = forwardRef(function (restProps, ref) { return (React.createElement(BaseButton, __assign({}, restProps, { ref: ref, colorStylesMap: colorStyles, styles: styles }))); });

export { ButtonMobile };
